import React from "react"
import { StyledAvatar } from "./styled"

const Avatar = ({ label }) => <StyledAvatar label={label} shape="circle" />

export default Avatar
